import { Suspense } from "react";

import FeatureGates from "@atlassian/feature-gate-js-client";

import {
    AtlSiteType,
    useLogMeIn
} from "@/components/confluence/hooks/variant-cfind-1109/use-log-me-in";
import GlobalFooter from "@/patterns/global-footer/src/index";
import GlobalNavigation from "@/patterns/global-nav/src/index";

import { ConfluenceSoftwarePageProps } from "../../../pages/confluence/confluence-software-page";

import { ConfluenceSoftwarePageExpcen4531 } from "./confluence-software-variant-expcen-4531";
import AdditionalResourcesSection from "./sections/additional-resources";
import { ConfluencePageBanner } from "./sections/banner";
import CtaSection from "./sections/cta";
import FeaturesSection from "./sections/features";
import HeroWithVideoSection from "./sections/hero";
import IntegrationsSection from "./sections/integrations";
import MobileSection from "./sections/mobile";
import PricingSection from "./sections/pricing";
import ResourcesSection from "./sections/resources";
import SocialProof from "./sections/social-proof";
import ConfluenceSoftwareNav from "./sections/software-confluence-navbar";
import TemplatesSection from "./sections/templates";
import TestimonialsSection from "./sections/testimonials";
import LogMeInVariantWithVideoSection from "./sections/variant-cfind-1109/hero";
import WhyConfluenceSection from "./sections/why-confluence";

export const ConfluenceSoftwarePage = ({
    pricing,
    availableProducts,
    userProfile
}: ConfluenceSoftwarePageProps) => {
    const { userProfileName, recentSites, shouldShowLogMeIn } = useLogMeIn({
        availableProducts,
        userProfile,
        siteType: AtlSiteType.CONFLUENCE
    });

    return (
        <div>
            <div>
                <GlobalNavigation
                    showTryNow={false}
                    color={"#f4f5f7"}
                    productKey="confluence"
                />
            </div>
            <ConfluenceSoftwareNav />
            <ConfluencePageBanner />
            {shouldShowLogMeIn ? (
                <LogMeInVariantWithVideoSection
                    userProfileName={userProfileName}
                    confluenceSites={recentSites}
                />
            ) : (
                <HeroWithVideoSection />
            )}
            <FeaturesSection />
            <WhyConfluenceSection />
            <TemplatesSection />
            <IntegrationsSection />
            <TestimonialsSection />
            <SocialProof />
            <ResourcesSection />
            <AdditionalResourcesSection />
            <Suspense>
                <PricingSection
                    serverSidePricing={pricing?.localizedPriceBlock?.confluence}
                />
            </Suspense>
            <MobileSection />
            <CtaSection />
            <GlobalFooter />
        </div>
    );
};

export const ConfluenceSoftwarePageTemplate = (
    props: ConfluenceSoftwarePageProps
) => {
    const productTourRefreshEnrollment = FeatureGates.getExperimentValue(
        "cfind-1106_confluence_product_tour_refresh",
        "enrolled",
        false
    );
    return productTourRefreshEnrollment ? (
        <div>
            <ConfluenceSoftwarePageExpcen4531 />
        </div>
    ) : (
        <ConfluenceSoftwarePage {...props} />
    );
};
